/** CRA injects only env vars prefixed with REACT_APP_. */
export function getClerkPublishableKey() {
  return process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ?? '';
}
